/* TONI HOMI cart drawer: upsell (V07 erbij / combi-switch) en Trustpilot herladen na re-render. */
(function(){
  function initTP(){ if(!window.Trustpilot) return; document.querySelectorAll('#CartDrawer .trustpilot-widget').forEach(function(el){ if(!el.querySelector('iframe')){ try{ window.Trustpilot.loadFromElement(el, true); }catch(e){} } }); }
  function patch(){
    var CD = customElements.get('cart-drawer'); if(!CD || CD.__th) return; CD.__th = true;
    var orig = CD.prototype.renderContents;
    if(orig){ CD.prototype.renderContents = function(s){ orig.call(this, s); setTimeout(initTP, 80); }; }
    var oOpen = CD.prototype.open;
    if(oOpen){ CD.prototype.open = function(t){ oOpen.call(this, t); setTimeout(initTP, 80); }; }
  }
  if(window.customElements){ customElements.whenDefined('cart-drawer').then(patch); }
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-th-upsell]'); if(!b) return;
    e.preventDefault(); if(b.disabled) return; b.disabled = true; var label = b.innerHTML; b.textContent = 'Even geduld…';
    var cd = document.querySelector('cart-drawer');
    var ids = (cd && cd.getSectionsToRender) ? cd.getSectionsToRender().map(function(s){ return s.id; }).join(',') : 'cart-drawer,cart-icon-bubble';
    var hdr = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    var p = Promise.resolve();
    if(b.dataset.remove){ p = fetch('/cart/change.js', { method:'POST', headers: hdr, body: JSON.stringify({ id: b.dataset.remove, quantity: 0 }) }); }
    p.then(function(){
      return fetch('/cart/add.js', { method:'POST', headers: hdr, body: JSON.stringify({ items:[{ id: parseInt(b.dataset.add, 10), quantity: parseInt(b.dataset.addQty || '1', 10) }], sections: ids }) });
    }).then(function(r){ return r.json(); }).then(function(j){
      if(j && j.sections && cd && cd.renderContents){ cd.renderContents(j); document.dispatchEvent(new CustomEvent('fsb:cart:update')); }
      else { window.location.reload(); }
    }).catch(function(){ b.disabled = false; b.innerHTML = label; });
  });
})();
/* bezorgbelofte met aftelling naar de cutoff (lokale tijd) */
(function(){
  function tick(){
    document.querySelectorAll('[data-th-promo]').forEach(function(el){
      var t=el.querySelector('[data-th-promo-title]'); if(!t) return;
      var cutoff=parseInt(el.dataset.cutoff||'18',10), now=new Date(), day=now.getDay();
      var end=new Date(now); end.setHours(cutoff,0,0,0);
      var diff=end-now;
      if(day>=1&&day<=5&&diff>0&&diff<12*3600e3){
        var h=Math.floor(diff/3600e3), m=Math.floor((diff%3600e3)/60e3);
        t.innerHTML='Bestel binnen <em>'+(h>0?h+'u ':'')+m+'m</em>, morgen in huis';
      } else { t.textContent='Voor 22:00 besteld, morgen in huis'; }
    });
  }
  tick(); setInterval(tick, 30000);
  if(window.customElements){ customElements.whenDefined('cart-drawer').then(function(){ var CD=customElements.get('cart-drawer'); var o=CD.prototype.renderContents; if(o&&!CD.__thp){ CD.__thp=true; CD.prototype.renderContents=function(s){ o.call(this,s); setTimeout(tick,60); }; } }); }
})();
